import React from "react";

import { defineMessages, useIntl } from "react-intl";

import CustomFieldValue from "@mapmycustomers/shared/types/customField/CustomFieldValue";
import { OptionalFields } from "@mapmycustomers/shared/util/ts";

import CustomField from "@app/component/CustomField";
import CustomFieldType from "@app/util/fieldModel/impl/CustomField";

interface Props {
  customField: CustomFieldType;
  disabled?: boolean;
  disableLabel?: boolean;
  onChange: (value: OptionalFields<CustomFieldValue, "id">) => void;
  value?: OptionalFields<CustomFieldValue, "id">;
}

const messages = defineMessages({
  changeTo: {
    id: "view.selectBar.button.bulkEdit.panel.custom.changeTo",
    defaultMessage: "Change {isMultiOption, select, true {value(s)} other {value}} to",
    description: "Bulk Edit change to custom field control label",
  },
});

const CustomFieldsEditor: React.FC<Props> = ({
  customField,
  disabled,
  disableLabel,
  onChange,
  value,
}) => {
  const intl = useIntl();

  return (
    <CustomField
      allowPreview={false}
      definition={customField.customFieldData}
      disabled={disabled}
      label={
        !disableLabel
          ? intl.formatMessage(messages.changeTo, {
              isMultiOption: customField.isMultiOptionField,
            })
          : undefined
      }
      onChange={onChange}
      value={value}
    />
  );
};

export default CustomFieldsEditor;
